// Text-to-Speech utility for voice catch logging
// Wraps @capacitor-community/text-to-speech for simple TTS usage
import { TextToSpeech } from '@capacitor-community/text-to-speech';

export async function speak(text, opts = {}) {
  return TextToSpeech.speak({
    text,
    lang: opts.lang || 'en-US',
    rate: opts.rate || 1.0,
    pitch: opts.pitch || 1.0,
    volume: opts.volume || 1.0,
    category: opts.category || 'ambient',
  });
}

export default { speak };
